import { render } from "./ProfileHomeFriendSubpage.vue?vue&type=template&id=2edd91b4&scoped=true"
import script from "./ProfileHomeFriendSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileHomeFriendSubpage.vue?vue&type=script&lang=js"

import "./ProfileHomeFriendSubpage.vue?vue&type=style&index=0&id=2edd91b4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edd91b4"]])

export default __exports__